module.exports = {
  CHANGE_PARAMETER: 'CHANGE_PARAMETER',
  START_QUICK_QUOTE: 'START_QUICK_QUOTE',

  START_QUOTE: 'START_QUOTE',
  QUOTED: 'QUOTED',
  ERROR_QUOTE: 'ERROR_QUOTE',

  START_SELECT_PRICE: 'START_SELECT_PRICE',
  SELECTED_PRICE: 'SELECTED_PRICE',
  ERROR_SELECT_PRICE: 'ERROR_SELECT_PRICE',

  START_LOAD_QUOTE: 'START_LOAD_QUOTE',
  LOADED_QUOTE: 'LOADED_QUOTE',
  ERROR_LOAD_QUOTE: 'ERROR_LOAD_QUOTEÍ',

  SHOW_EMAIL_FORM: 'SHOW_EMAIL_FORM',
  START_SEND_EMAIL: 'START_SEND_EMAIL',
  SENT_EMAIL: 'SENT_EMAIL',
  ERROR_SEND_EMAIL: 'ERROR_SEND_EMAIL'
};